// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Prevent horizontal scroll on mobile */
  overflow-x: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* ======== MOBILE RESPONSIVE GLOBAL STYLES ======== */

/* Remove tap highlight on mobile buttons */
button,
a {
  -webkit-tap-highlight-color: transparent;
}

/* Tables responsive global styles */
.ant-table-wrapper {
  max-width: 100%;
  width: 100%;
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch;
}

.ant-table-wrapper .ant-table-container {
  max-width: 100%;
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch;
}

.ant-table-wrapper .ant-table-content {
  max-width: 100%;
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch;
}

.ant-table-wrapper .ant-table {
  width: 100%;
  min-width: 100%;
}

/* Ensure mobile cards fit viewport without creating duplicate scrollbars */
.ant-card-body {
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Mobile specific overrides */
@media (max-width: 767px) {

  /* Tables horizontal scrolling & responsive containment */
  .ant-table-wrapper {
    max-width: 100vw !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
    margin-left: -4px;
    margin-right: -4px;
  }

  .ant-table-wrapper .ant-table {
    min-width: 650px; /* Preserve column integrity and allow smooth horizontal swipe */
    font-size: 12px;
  }

  .ant-table-wrapper .ant-table-thead > tr > th,
  .ant-table-wrapper .ant-table-tbody > tr > td {
    padding: 6px 8px !important;
    font-size: 12px !important;
  }

  /* Pagination wrap cleanly on mobile screens */
  .ant-table-pagination.ant-pagination {
    flex-wrap: wrap !important;
    justify-content: center !important;
    row-gap: 8px !important;
    margin: 12px 0 !important;
  }

  .ant-table-pagination .ant-pagination-total-text {
    width: 100% !important;
    text-align: center !important;
    margin-bottom: 4px !important;
    font-size: 12px !important;
  }

  /* Modals fit viewport */
  .ant-modal {
    max-width: calc(100vw - 16px) !important;
    margin: 8px auto !important;
  }

  .ant-modal-content {
    border-radius: 12px !important;
    padding: 16px 12px !important;
  }

  /* Inline forms stack vertically */
  .ant-form-inline .ant-form-item {
    width: 100% !important;
    margin-bottom: 8px !important;
  }

  /* Cards rounded corners & padding */
  .ant-card {
    border-radius: 8px !important;
  }

  .ant-card-body {
    padding: 12px 8px !important;
    overflow-x: auto !important;
  }

  /* Prevent text overflow in descriptions */
  .ant-descriptions-item-content {
    word-break: break-word;
  }

  /* Content area no overflow */
  .ant-layout-content {
    min-width: 0;
    overflow-x: hidden;
    padding: 8px 4px !important;
  }

  /* Drawer scrollable */
  .ant-drawer-body {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* Tabs scroll on small screens */
  .ant-tabs-nav-wrap {
    overflow-x: auto !important;
  }

  /* Select dropdown size */
  .ant-select-dropdown {
    max-width: 90vw;
  }

  /* Action buttons in tables */
  .ant-space {
    flex-wrap: wrap;
  }

  /* Excel spreadsheet custom tables */
  .excel-form-table {
    min-width: 800px !important;
    display: table;
  }

  .excel-header-bar,
  .excel-summary-box {
    padding: 10px !important;
  }
}

/* ======== LAYOUT SYSTEM CUSTOM STYLES ======== */

/* Glassmorphism utility */
.glass-header {
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  background: rgba(15, 23, 42, 0.75) !important;
}

/* Horizontal Top Navbar customization */
.top-nav-menu {
  line-height: 64px !important;
  border-bottom: none !important;
}

.top-nav-menu .ant-menu-item {
  border-radius: 6px;
  margin: 0 4px !important;
  height: 40px !important;
  line-height: 40px !important;
  top: 12px;
}

/* Rail layout item buttons */
.rail-nav-btn {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent;
  border: none;
  color: var(--text-secondary);
  position: relative;
}

.rail-nav-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--primary-color);
  transform: translateY(-2px);
}

.rail-nav-btn.active {
  background: var(--primary-color);
  color: #ffffff !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
}

/* Smooth layout transitions */
.layout-content-wrapper {
  animation: fadeInLayout 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes fadeInLayout {
  from {
    opacity: 0;
    transform: translateY(6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}


/* ==========================================
   EXCEL-LIKE TABLE & FORM STYLING (GLOBAL)
   ========================================== */
:root,
[data-theme='light'] {
  color-scheme: light;
  --excel-gridline: #d1d5db;
  /* Tailwind gray-300 */
  --excel-header-bg: #f3f4f6;
  /* Tailwind gray-100 */
  --excel-zebra-bg: #f9fafb;
  /* Tailwind gray-50 */
  --excel-hover-bg: #f3f4f6;
  --excel-card-bg: #ffffff;
  --excel-input-bg: #ffffff;
  --excel-input-border: #d9d9d9;
  --excel-readonly-bg: rgba(0, 0, 0, 0.03);
}

[data-theme='dark'] {
  color-scheme: dark;
  --excel-gridline: #374151;
  /* Tailwind gray-700 */
  --excel-header-bg: #1e293b;
  /* Tailwind gray-800 */
  --excel-zebra-bg: #0f172a;
  /* Tailwind gray-900 */
  --excel-hover-bg: #1f2937;
  --excel-card-bg: #0b0f19;
  --excel-input-bg: #1e293b;
  --excel-input-border: #475569;
  --excel-readonly-bg: rgba(255, 255, 255, 0.05);
}

.ant-table-wrapper {
  border: 1px solid var(--excel-gridline) !important;
  border-radius: 0px !important;
  margin-bottom: 16px;
}

.ant-table-wrapper .ant-table-container,
.ant-table-wrapper .ant-table,
.ant-table-wrapper .ant-table-content,
.ant-table-wrapper .ant-table-header,
.ant-table-wrapper .ant-table-body {
  border-radius: 0px !important;
}

/* Grid Cell Styling */
.ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-tbody>tr>td,
.ant-table-wrapper .ant-table-summary tr td {
  border-right: 1px solid var(--excel-gridline) !important;
  border-bottom: 1px solid var(--excel-gridline) !important;
  padding: 5px 8px !important;
  /* Compact spreadsheet padding */
  font-size: 13px !important;
  border-radius: 0px !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif !important;
}

/* Strip right border on the last column to prevent double border with wrapper */
.ant-table-wrapper .ant-table-thead>tr>th:last-child,
.ant-table-wrapper .ant-table-tbody>tr>td:last-child,
.ant-table-wrapper .ant-table-summary tr td:last-child {
  border-right: none !important;
}

/* Spreadsheet Headers */
.ant-table-wrapper .ant-table-thead>tr>th {
  background: var(--excel-header-bg) !important;
  color: var(--text-color) !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  font-size: 11px !important;
  letter-spacing: 0.05em;
}

/* Zebra Striping */
.ant-table-wrapper .ant-table-tbody>tr:nth-child(even) {
  background: var(--excel-zebra-bg) !important;
}

.ant-table-wrapper .ant-table-tbody>tr:nth-child(odd) {
  background: transparent !important;
}

/* Row Hover Highlights */
.ant-table-wrapper .ant-table-tbody>tr.ant-table-row:hover>td {
  background: var(--excel-hover-bg) !important;
}

/* Summary Row styling */
.ant-table-wrapper .ant-table-summary tr td {
  background: var(--excel-header-bg) !important;
  font-weight: bold;
}

/* ==========================================
   EXCEL FORM TABLE & MODAL SPREADSHEET STYLES
   ========================================== */
.excel-form-table {
  width: 100%;
  min-width: 1300px;
  border-collapse: collapse;
  border: 1px solid var(--excel-gridline, #d1d5db);
  background: var(--excel-card-bg, #ffffff);
}

.excel-form-table th {
  background: var(--excel-header-bg, #f3f4f6);
  color: var(--text-color, #1e293b);
  border-right: 1px solid var(--excel-gridline, #d1d5db);
  border-bottom: 2px solid var(--excel-gridline, #cbd5e1);
  padding: 8px 6px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  text-align: left;
}

.excel-form-table th:last-child {
  border-right: none;
}

.excel-form-table td {
  border-right: 1px solid var(--excel-gridline, #e2e8f0);
  border-bottom: 1px solid var(--excel-gridline, #e2e8f0);
  padding: 4px 6px;
  vertical-align: middle;
  background-color: var(--excel-card-bg, #ffffff);
  color: var(--text-color, #1e293b);
}

.excel-form-table td:last-child {
  border-right: none;
}

.excel-form-table tr:nth-child(even) td {
  background-color: var(--excel-zebra-bg, #f8fafc);
}

.excel-cell-input {
  border-radius: 2px !important;
  border: 1px solid var(--excel-input-border, #d9d9d9) !important;
  box-shadow: none !important;
  background: var(--excel-input-bg, #ffffff) !important;
  color: var(--text-color, inherit) !important;
  font-family: inherit;
  font-size: 13px;
  transition: all 0.2s ease-in-out;
}

.excel-cell-input input,
.excel-cell-input.ant-input {
  background: transparent !important;
  color: var(--text-color, inherit) !important;
}

.excel-cell-input .ant-input-prefix {
  color: var(--text-secondary, rgba(0, 0, 0, 0.45)) !important;
}

.excel-cell-input:focus,
.excel-cell-input:focus-within {
  border-color: var(--primary-color, #1890ff) !important;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.25) !important;
}

.excel-cell-readonly,
.excel-cell-readonly.ant-input,
.excel-cell-readonly.ant-input-affix-wrapper {
  font-weight: 600;
  background: var(--excel-readonly-bg, rgba(0, 0, 0, 0.03)) !important;
  border-color: var(--excel-gridline, #e5e7eb) !important;
  color: var(--text-color, inherit) !important;
}

.excel-cell-readonly input {
  background: transparent !important;
  color: var(--text-color, inherit) !important;
}

.excel-summary-box {
  background: var(--excel-header-bg, #f8fafc);
  border: 1px solid var(--excel-gridline, #cbd5e1);
  padding: 14px;
  border-radius: 4px;
  color: var(--text-color, #1e293b);
}

.excel-header-bar {
  background: var(--excel-header-bg, #f3f4f6);
  border: 1px solid var(--excel-gridline, #d1d5db);
  padding: 14px;
  margin-bottom: 16px;
  border-radius: 4px;
  color: var(--text-color, #1e293b);
}

[data-theme='dark'] input[type="date"] {
  color-scheme: dark;
}

/* =========================================================
   VIDEO DOWNLOAD PROTECTION
   Disable native download buttons and right-click download options
   ========================================================= */
video::-internal-media-controls-download-button {
  display: none !important;
}

video::-webkit-media-controls-download-button {
  display: none !important;
}

video::-webkit-media-controls-enclosure {
  overflow: hidden;
}

video {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

/* =========================================================
   SIDEBAR SCROLLABLE STYLES
   ========================================================= */
.vedika-desktop-sider .ant-layout-sider-children {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  overflow: hidden !important;
}

.sidebar-menu-scroll-container {
  scrollbar-width: thin;
  scrollbar-color: rgba(150, 150, 150, 0.35) transparent;
}

.sidebar-menu-scroll-container::-webkit-scrollbar {
  width: 5px;
}

.sidebar-menu-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-menu-scroll-container::-webkit-scrollbar-thumb {
  background: rgba(150, 150, 150, 0.25);
  border-radius: 4px;
}

.sidebar-menu-scroll-container::-webkit-scrollbar-thumb:hover {
  background: rgba(150, 150, 150, 0.55);
}

/* =========================================================
   DARK MODE & ATTENDANCE MANAGEMENT THEME STYLES
   ========================================================= */

/* Fixed Column Background Overrides in Dark Mode */
[data-theme='dark'] .ant-table-wrapper .ant-table-cell-fix-left,
[data-theme='dark'] .ant-table-wrapper .ant-table-cell-fix-right {
  background: var(--panel-color) !important;
  color: var(--text-color) !important;
}

[data-theme='dark'] .ant-table-wrapper .ant-table-thead > tr > .ant-table-cell-fix-left,
[data-theme='dark'] .ant-table-wrapper .ant-table-thead > tr > .ant-table-cell-fix-right {
  background: var(--excel-header-bg) !important;
  color: var(--text-color) !important;
}

[data-theme='dark'] .ant-table-wrapper .ant-table-tbody > tr:nth-child(even) > .ant-table-cell-fix-left,
[data-theme='dark'] .ant-table-wrapper .ant-table-tbody > tr:nth-child(even) > .ant-table-cell-fix-right {
  background: var(--excel-zebra-bg) !important;
}

[data-theme='dark'] .ant-table-wrapper .ant-table-tbody > tr.ant-table-row:hover > .ant-table-cell-fix-left,
[data-theme='dark'] .ant-table-wrapper .ant-table-tbody > tr.ant-table-row:hover > .ant-table-cell-fix-right {
  background: var(--excel-hover-bg) !important;
}

[data-theme='dark'] .ant-table-wrapper .ant-table-summary tr .ant-table-cell-fix-left,
[data-theme='dark'] .ant-table-wrapper .ant-table-summary tr .ant-table-cell-fix-right {
  background: var(--excel-header-bg) !important;
}

/* Card Tabs Dark Mode */
[data-theme='dark'] .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
  background: var(--panel-color) !important;
  border-color: var(--border-color) !important;
  color: var(--text-secondary) !important;
}

[data-theme='dark'] .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {
  background: var(--bg-color) !important;
  border-bottom-color: var(--bg-color) !important;
}

[data-theme='dark'] .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: var(--primary-color) !important;
  font-weight: 600;
}

[data-theme='dark'] .ant-tabs-nav:before {
  border-bottom-color: var(--border-color) !important;
}

/* Card Components & Titles in Dark Mode */
[data-theme='dark'] .ant-card {
  background: var(--panel-color);
  border-color: var(--border-color);
  color: var(--text-color);
}

[data-theme='dark'] .ant-card-head {
  border-bottom-color: var(--border-color) !important;
  color: var(--text-color) !important;
}

[data-theme='dark'] .ant-card-head-title {
  color: var(--text-color) !important;
}

/* Ant Design Statistics */
[data-theme='dark'] .ant-statistic-title {
  color: var(--text-secondary) !important;
}

[data-theme='dark'] .ant-statistic-content {
  color: var(--text-color) !important;
}

/* Modal and Dropdown popups */
[data-theme='dark'] .ant-modal-content,
[data-theme='dark'] .ant-modal-header {
  background: var(--panel-color) !important;
  color: var(--text-color) !important;
}

[data-theme='dark'] .ant-modal-title {
  color: var(--text-color) !important;
}

[data-theme='dark'] .ant-modal-close {
  color: var(--text-secondary) !important;
}

[data-theme='dark'] .ant-form-item-label > label {
  color: var(--text-color) !important;
}

[data-theme='dark'] .ant-descriptions-item-label {
  color: var(--text-secondary) !important;
}

[data-theme='dark'] .ant-descriptions-item-content {
  color: var(--text-color) !important;
}

[data-theme='dark'] .ant-empty-description {
  color: var(--text-secondary) !important;
}

/* Table Filter Dropdown in Dark Mode */
[data-theme='dark'] .ant-table-filter-dropdown {
  background: var(--panel-color) !important;
  border: 1px solid var(--border-color) !important;
}

[data-theme='dark'] .ant-table-filter-dropdown-btns {
  border-top-color: var(--border-color) !important;
}

/* Attendance Matrix Cells High Contrast in Dark Mode */
[data-theme='dark'] .attendance-matrix-cell {
  border-color: var(--excel-gridline) !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE;aACW;AACb;;AAEA,sDAAsD;;AAEtD,2CAA2C;AAC3C;;EAEE,wCAAwC;AAC1C;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,2EAA2E;AAC3E;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,8BAA8B;AAC9B;;EAEE,yDAAyD;EACzD;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,iCAAiC;IACjC,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB,EAAE,gEAAgE;IAClF,eAAe;EACjB;;EAEA;;IAEE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA,8CAA8C;EAC9C;IACE,0BAA0B;IAC1B,kCAAkC;IAClC,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA,wBAAwB;EACxB;IACE,wCAAwC;IACxC,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA,kCAAkC;EAClC;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA,oCAAoC;EACpC;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA,0CAA0C;EAC1C;IACE,sBAAsB;EACxB;;EAEA,6BAA6B;EAC7B;IACE,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA,sBAAsB;EACtB;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,iCAAiC;EACjC;IACE,2BAA2B;EAC7B;;EAEA,yBAAyB;EACzB;IACE,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;IACE,eAAe;EACjB;;EAEA,oCAAoC;EACpC;IACE,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;;IAEE,wBAAwB;EAC1B;AACF;;AAEA,kDAAkD;;AAElD,0BAA0B;AAC1B;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA,wCAAwC;AACxC;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,kDAAkD;EAClD,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA,8BAA8B;AAC9B;EACE,0DAA0D;AAC5D;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;;AAGA;;+CAE+C;AAC/C;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,kDAAkD;EAClD,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;;;EAGE,wDAAwD;EACxD,yDAAyD;EACzD,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,6BAA6B;EAC7B,2GAA2G;AAC7G;;AAEA,gFAAgF;AAChF;;;EAGE,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,6CAA6C;EAC7C,mCAAmC;EACnC,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,4CAA4C;AAC9C;;AAEA,wBAAwB;AACxB;EACE,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;;+CAE+C;AAC/C;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,gDAAgD;EAChD,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,sDAAsD;EACtD,uDAAuD;EACvD,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,uDAAuD;EACvD,gBAAgB;EAChB,sBAAsB;EACtB,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,+DAA+D;EAC/D,2BAA2B;EAC3B,qDAAqD;EACrD,4CAA4C;EAC5C,oBAAoB;EACpB,eAAe;EACf,gCAAgC;AAClC;;AAEA;;EAEE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;;EAEE,sDAAsD;EACtD,yDAAyD;AAC3D;;AAEA;;;EAGE,gBAAgB;EAChB,oEAAoE;EACpE,uDAAuD;EACvD,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,gDAAgD;EAChD,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;EAC3C,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;8DAG8D;AAC9D;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;8DAE8D;AAC9D;EACE,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;8DAE8D;;AAE9D,mDAAmD;AACnD;;EAEE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;;EAEE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE,yCAAyC;EACzC,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;AACrD;;AAEA,0CAA0C;AAC1C;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,mDAAmD;EACnD,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,0BAA0B;AAC1B;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;;EAEE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,uCAAuC;AACvC;EACE,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA,uDAAuD;AACvD;EACE,8CAA8C;AAChD","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* Prevent horizontal scroll on mobile */\n  overflow-x: hidden;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* ======== MOBILE RESPONSIVE GLOBAL STYLES ======== */\n\n/* Remove tap highlight on mobile buttons */\nbutton,\na {\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* Tables responsive global styles */\n.ant-table-wrapper {\n  max-width: 100%;\n  width: 100%;\n  overflow-x: auto !important;\n  -webkit-overflow-scrolling: touch;\n}\n\n.ant-table-wrapper .ant-table-container {\n  max-width: 100%;\n  overflow-x: auto !important;\n  -webkit-overflow-scrolling: touch;\n}\n\n.ant-table-wrapper .ant-table-content {\n  max-width: 100%;\n  overflow-x: auto !important;\n  -webkit-overflow-scrolling: touch;\n}\n\n.ant-table-wrapper .ant-table {\n  width: 100%;\n  min-width: 100%;\n}\n\n/* Ensure mobile cards fit viewport without creating duplicate scrollbars */\n.ant-card-body {\n  max-width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Mobile specific overrides */\n@media (max-width: 767px) {\n\n  /* Tables horizontal scrolling & responsive containment */\n  .ant-table-wrapper {\n    max-width: 100vw !important;\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch;\n    margin-left: -4px;\n    margin-right: -4px;\n  }\n\n  .ant-table-wrapper .ant-table {\n    min-width: 650px; /* Preserve column integrity and allow smooth horizontal swipe */\n    font-size: 12px;\n  }\n\n  .ant-table-wrapper .ant-table-thead > tr > th,\n  .ant-table-wrapper .ant-table-tbody > tr > td {\n    padding: 6px 8px !important;\n    font-size: 12px !important;\n  }\n\n  /* Pagination wrap cleanly on mobile screens */\n  .ant-table-pagination.ant-pagination {\n    flex-wrap: wrap !important;\n    justify-content: center !important;\n    row-gap: 8px !important;\n    margin: 12px 0 !important;\n  }\n\n  .ant-table-pagination .ant-pagination-total-text {\n    width: 100% !important;\n    text-align: center !important;\n    margin-bottom: 4px !important;\n    font-size: 12px !important;\n  }\n\n  /* Modals fit viewport */\n  .ant-modal {\n    max-width: calc(100vw - 16px) !important;\n    margin: 8px auto !important;\n  }\n\n  .ant-modal-content {\n    border-radius: 12px !important;\n    padding: 16px 12px !important;\n  }\n\n  /* Inline forms stack vertically */\n  .ant-form-inline .ant-form-item {\n    width: 100% !important;\n    margin-bottom: 8px !important;\n  }\n\n  /* Cards rounded corners & padding */\n  .ant-card {\n    border-radius: 8px !important;\n  }\n\n  .ant-card-body {\n    padding: 12px 8px !important;\n    overflow-x: auto !important;\n  }\n\n  /* Prevent text overflow in descriptions */\n  .ant-descriptions-item-content {\n    word-break: break-word;\n  }\n\n  /* Content area no overflow */\n  .ant-layout-content {\n    min-width: 0;\n    overflow-x: hidden;\n    padding: 8px 4px !important;\n  }\n\n  /* Drawer scrollable */\n  .ant-drawer-body {\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* Tabs scroll on small screens */\n  .ant-tabs-nav-wrap {\n    overflow-x: auto !important;\n  }\n\n  /* Select dropdown size */\n  .ant-select-dropdown {\n    max-width: 90vw;\n  }\n\n  /* Action buttons in tables */\n  .ant-space {\n    flex-wrap: wrap;\n  }\n\n  /* Excel spreadsheet custom tables */\n  .excel-form-table {\n    min-width: 800px !important;\n    display: table;\n  }\n\n  .excel-header-bar,\n  .excel-summary-box {\n    padding: 10px !important;\n  }\n}\n\n/* ======== LAYOUT SYSTEM CUSTOM STYLES ======== */\n\n/* Glassmorphism utility */\n.glass-header {\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  background: rgba(15, 23, 42, 0.75) !important;\n}\n\n/* Horizontal Top Navbar customization */\n.top-nav-menu {\n  line-height: 64px !important;\n  border-bottom: none !important;\n}\n\n.top-nav-menu .ant-menu-item {\n  border-radius: 6px;\n  margin: 0 4px !important;\n  height: 40px !important;\n  line-height: 40px !important;\n  top: 12px;\n}\n\n/* Rail layout item buttons */\n.rail-nav-btn {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  position: relative;\n}\n\n.rail-nav-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--primary-color);\n  transform: translateY(-2px);\n}\n\n.rail-nav-btn.active {\n  background: var(--primary-color);\n  color: #ffffff !important;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);\n}\n\n/* Smooth layout transitions */\n.layout-content-wrapper {\n  animation: fadeInLayout 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes fadeInLayout {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n/* ==========================================\n   EXCEL-LIKE TABLE & FORM STYLING (GLOBAL)\n   ========================================== */\n:root,\n[data-theme='light'] {\n  color-scheme: light;\n  --excel-gridline: #d1d5db;\n  /* Tailwind gray-300 */\n  --excel-header-bg: #f3f4f6;\n  /* Tailwind gray-100 */\n  --excel-zebra-bg: #f9fafb;\n  /* Tailwind gray-50 */\n  --excel-hover-bg: #f3f4f6;\n  --excel-card-bg: #ffffff;\n  --excel-input-bg: #ffffff;\n  --excel-input-border: #d9d9d9;\n  --excel-readonly-bg: rgba(0, 0, 0, 0.03);\n}\n\n[data-theme='dark'] {\n  color-scheme: dark;\n  --excel-gridline: #374151;\n  /* Tailwind gray-700 */\n  --excel-header-bg: #1e293b;\n  /* Tailwind gray-800 */\n  --excel-zebra-bg: #0f172a;\n  /* Tailwind gray-900 */\n  --excel-hover-bg: #1f2937;\n  --excel-card-bg: #0b0f19;\n  --excel-input-bg: #1e293b;\n  --excel-input-border: #475569;\n  --excel-readonly-bg: rgba(255, 255, 255, 0.05);\n}\n\n.ant-table-wrapper {\n  border: 1px solid var(--excel-gridline) !important;\n  border-radius: 0px !important;\n  margin-bottom: 16px;\n}\n\n.ant-table-wrapper .ant-table-container,\n.ant-table-wrapper .ant-table,\n.ant-table-wrapper .ant-table-content,\n.ant-table-wrapper .ant-table-header,\n.ant-table-wrapper .ant-table-body {\n  border-radius: 0px !important;\n}\n\n/* Grid Cell Styling */\n.ant-table-wrapper .ant-table-thead>tr>th,\n.ant-table-wrapper .ant-table-tbody>tr>td,\n.ant-table-wrapper .ant-table-summary tr td {\n  border-right: 1px solid var(--excel-gridline) !important;\n  border-bottom: 1px solid var(--excel-gridline) !important;\n  padding: 5px 8px !important;\n  /* Compact spreadsheet padding */\n  font-size: 13px !important;\n  border-radius: 0px !important;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif !important;\n}\n\n/* Strip right border on the last column to prevent double border with wrapper */\n.ant-table-wrapper .ant-table-thead>tr>th:last-child,\n.ant-table-wrapper .ant-table-tbody>tr>td:last-child,\n.ant-table-wrapper .ant-table-summary tr td:last-child {\n  border-right: none !important;\n}\n\n/* Spreadsheet Headers */\n.ant-table-wrapper .ant-table-thead>tr>th {\n  background: var(--excel-header-bg) !important;\n  color: var(--text-color) !important;\n  font-weight: 600 !important;\n  text-transform: uppercase;\n  font-size: 11px !important;\n  letter-spacing: 0.05em;\n}\n\n/* Zebra Striping */\n.ant-table-wrapper .ant-table-tbody>tr:nth-child(even) {\n  background: var(--excel-zebra-bg) !important;\n}\n\n.ant-table-wrapper .ant-table-tbody>tr:nth-child(odd) {\n  background: transparent !important;\n}\n\n/* Row Hover Highlights */\n.ant-table-wrapper .ant-table-tbody>tr.ant-table-row:hover>td {\n  background: var(--excel-hover-bg) !important;\n}\n\n/* Summary Row styling */\n.ant-table-wrapper .ant-table-summary tr td {\n  background: var(--excel-header-bg) !important;\n  font-weight: bold;\n}\n\n/* ==========================================\n   EXCEL FORM TABLE & MODAL SPREADSHEET STYLES\n   ========================================== */\n.excel-form-table {\n  width: 100%;\n  min-width: 1300px;\n  border-collapse: collapse;\n  border: 1px solid var(--excel-gridline, #d1d5db);\n  background: var(--excel-card-bg, #ffffff);\n}\n\n.excel-form-table th {\n  background: var(--excel-header-bg, #f3f4f6);\n  color: var(--text-color, #1e293b);\n  border-right: 1px solid var(--excel-gridline, #d1d5db);\n  border-bottom: 2px solid var(--excel-gridline, #cbd5e1);\n  padding: 8px 6px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  text-align: left;\n}\n\n.excel-form-table th:last-child {\n  border-right: none;\n}\n\n.excel-form-table td {\n  border-right: 1px solid var(--excel-gridline, #e2e8f0);\n  border-bottom: 1px solid var(--excel-gridline, #e2e8f0);\n  padding: 4px 6px;\n  vertical-align: middle;\n  background-color: var(--excel-card-bg, #ffffff);\n  color: var(--text-color, #1e293b);\n}\n\n.excel-form-table td:last-child {\n  border-right: none;\n}\n\n.excel-form-table tr:nth-child(even) td {\n  background-color: var(--excel-zebra-bg, #f8fafc);\n}\n\n.excel-cell-input {\n  border-radius: 2px !important;\n  border: 1px solid var(--excel-input-border, #d9d9d9) !important;\n  box-shadow: none !important;\n  background: var(--excel-input-bg, #ffffff) !important;\n  color: var(--text-color, inherit) !important;\n  font-family: inherit;\n  font-size: 13px;\n  transition: all 0.2s ease-in-out;\n}\n\n.excel-cell-input input,\n.excel-cell-input.ant-input {\n  background: transparent !important;\n  color: var(--text-color, inherit) !important;\n}\n\n.excel-cell-input .ant-input-prefix {\n  color: var(--text-secondary, rgba(0, 0, 0, 0.45)) !important;\n}\n\n.excel-cell-input:focus,\n.excel-cell-input:focus-within {\n  border-color: var(--primary-color, #1890ff) !important;\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.25) !important;\n}\n\n.excel-cell-readonly,\n.excel-cell-readonly.ant-input,\n.excel-cell-readonly.ant-input-affix-wrapper {\n  font-weight: 600;\n  background: var(--excel-readonly-bg, rgba(0, 0, 0, 0.03)) !important;\n  border-color: var(--excel-gridline, #e5e7eb) !important;\n  color: var(--text-color, inherit) !important;\n}\n\n.excel-cell-readonly input {\n  background: transparent !important;\n  color: var(--text-color, inherit) !important;\n}\n\n.excel-summary-box {\n  background: var(--excel-header-bg, #f8fafc);\n  border: 1px solid var(--excel-gridline, #cbd5e1);\n  padding: 14px;\n  border-radius: 4px;\n  color: var(--text-color, #1e293b);\n}\n\n.excel-header-bar {\n  background: var(--excel-header-bg, #f3f4f6);\n  border: 1px solid var(--excel-gridline, #d1d5db);\n  padding: 14px;\n  margin-bottom: 16px;\n  border-radius: 4px;\n  color: var(--text-color, #1e293b);\n}\n\n[data-theme='dark'] input[type=\"date\"] {\n  color-scheme: dark;\n}\n\n/* =========================================================\n   VIDEO DOWNLOAD PROTECTION\n   Disable native download buttons and right-click download options\n   ========================================================= */\nvideo::-internal-media-controls-download-button {\n  display: none !important;\n}\n\nvideo::-webkit-media-controls-download-button {\n  display: none !important;\n}\n\nvideo::-webkit-media-controls-enclosure {\n  overflow: hidden;\n}\n\nvideo {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n/* =========================================================\n   SIDEBAR SCROLLABLE STYLES\n   ========================================================= */\n.vedika-desktop-sider .ant-layout-sider-children {\n  display: flex !important;\n  flex-direction: column !important;\n  height: 100% !important;\n  overflow: hidden !important;\n}\n\n.sidebar-menu-scroll-container {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(150, 150, 150, 0.35) transparent;\n}\n\n.sidebar-menu-scroll-container::-webkit-scrollbar {\n  width: 5px;\n}\n\n.sidebar-menu-scroll-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar-menu-scroll-container::-webkit-scrollbar-thumb {\n  background: rgba(150, 150, 150, 0.25);\n  border-radius: 4px;\n}\n\n.sidebar-menu-scroll-container::-webkit-scrollbar-thumb:hover {\n  background: rgba(150, 150, 150, 0.55);\n}\n\n/* =========================================================\n   DARK MODE & ATTENDANCE MANAGEMENT THEME STYLES\n   ========================================================= */\n\n/* Fixed Column Background Overrides in Dark Mode */\n[data-theme='dark'] .ant-table-wrapper .ant-table-cell-fix-left,\n[data-theme='dark'] .ant-table-wrapper .ant-table-cell-fix-right {\n  background: var(--panel-color) !important;\n  color: var(--text-color) !important;\n}\n\n[data-theme='dark'] .ant-table-wrapper .ant-table-thead > tr > .ant-table-cell-fix-left,\n[data-theme='dark'] .ant-table-wrapper .ant-table-thead > tr > .ant-table-cell-fix-right {\n  background: var(--excel-header-bg) !important;\n  color: var(--text-color) !important;\n}\n\n[data-theme='dark'] .ant-table-wrapper .ant-table-tbody > tr:nth-child(even) > .ant-table-cell-fix-left,\n[data-theme='dark'] .ant-table-wrapper .ant-table-tbody > tr:nth-child(even) > .ant-table-cell-fix-right {\n  background: var(--excel-zebra-bg) !important;\n}\n\n[data-theme='dark'] .ant-table-wrapper .ant-table-tbody > tr.ant-table-row:hover > .ant-table-cell-fix-left,\n[data-theme='dark'] .ant-table-wrapper .ant-table-tbody > tr.ant-table-row:hover > .ant-table-cell-fix-right {\n  background: var(--excel-hover-bg) !important;\n}\n\n[data-theme='dark'] .ant-table-wrapper .ant-table-summary tr .ant-table-cell-fix-left,\n[data-theme='dark'] .ant-table-wrapper .ant-table-summary tr .ant-table-cell-fix-right {\n  background: var(--excel-header-bg) !important;\n}\n\n/* Card Tabs Dark Mode */\n[data-theme='dark'] .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {\n  background: var(--panel-color) !important;\n  border-color: var(--border-color) !important;\n  color: var(--text-secondary) !important;\n}\n\n[data-theme='dark'] .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {\n  background: var(--bg-color) !important;\n  border-bottom-color: var(--bg-color) !important;\n}\n\n[data-theme='dark'] .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: var(--primary-color) !important;\n  font-weight: 600;\n}\n\n[data-theme='dark'] .ant-tabs-nav:before {\n  border-bottom-color: var(--border-color) !important;\n}\n\n/* Card Components & Titles in Dark Mode */\n[data-theme='dark'] .ant-card {\n  background: var(--panel-color);\n  border-color: var(--border-color);\n  color: var(--text-color);\n}\n\n[data-theme='dark'] .ant-card-head {\n  border-bottom-color: var(--border-color) !important;\n  color: var(--text-color) !important;\n}\n\n[data-theme='dark'] .ant-card-head-title {\n  color: var(--text-color) !important;\n}\n\n/* Ant Design Statistics */\n[data-theme='dark'] .ant-statistic-title {\n  color: var(--text-secondary) !important;\n}\n\n[data-theme='dark'] .ant-statistic-content {\n  color: var(--text-color) !important;\n}\n\n/* Modal and Dropdown popups */\n[data-theme='dark'] .ant-modal-content,\n[data-theme='dark'] .ant-modal-header {\n  background: var(--panel-color) !important;\n  color: var(--text-color) !important;\n}\n\n[data-theme='dark'] .ant-modal-title {\n  color: var(--text-color) !important;\n}\n\n[data-theme='dark'] .ant-modal-close {\n  color: var(--text-secondary) !important;\n}\n\n[data-theme='dark'] .ant-form-item-label > label {\n  color: var(--text-color) !important;\n}\n\n[data-theme='dark'] .ant-descriptions-item-label {\n  color: var(--text-secondary) !important;\n}\n\n[data-theme='dark'] .ant-descriptions-item-content {\n  color: var(--text-color) !important;\n}\n\n[data-theme='dark'] .ant-empty-description {\n  color: var(--text-secondary) !important;\n}\n\n/* Table Filter Dropdown in Dark Mode */\n[data-theme='dark'] .ant-table-filter-dropdown {\n  background: var(--panel-color) !important;\n  border: 1px solid var(--border-color) !important;\n}\n\n[data-theme='dark'] .ant-table-filter-dropdown-btns {\n  border-top-color: var(--border-color) !important;\n}\n\n/* Attendance Matrix Cells High Contrast in Dark Mode */\n[data-theme='dark'] .attendance-matrix-cell {\n  border-color: var(--excel-gridline) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
